export const permissionCategory = {
    SUPER_ADMIN: "super_admin",
    ADMIN_USER_MANAGEMENT: "admin_user_management",
    STORE_MANAGEMENT: "store_management",
    PAYMENT_MANAGEMENT: "payment_management",
    COMMON: "common",
    PRODUCT_MANAGEMENT: "product_management"
};